import { NgModule } from '@angular/core';
import { PRODUCT_CARD_FEATURE_NAME } from '@epicuro-next/constants/rule-engine/product-card-rules';
import { DataMerchandiseModule } from '@epicuro-next/data/merchandise';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { SessionStateModule } from '@epicuro-next/state/session-state';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { merchandiseFeatureKey } from './constants';
import { MerchandiseMarketingEffects } from './state/effects';
import { initialState, reducer } from './state/reducers';
import { resetStateMetaReducer } from '@epicuro-next/state/meta-reducers';

@NgModule({
  imports: [
    DataMerchandiseModule,
    SessionStateModule,
    ConfigurationModule.forFeature(PRODUCT_CARD_FEATURE_NAME),
    EffectsModule.forFeature([MerchandiseMarketingEffects]),
    StoreModule.forFeature(merchandiseFeatureKey, reducer, {
      metaReducers: [resetStateMetaReducer(initialState)],
    }),
  ],
})
export class MerchandiseStateModule {}
